// La fiche d'une commande ouverte depuis une liste sait d'où l'on vient, pour que « retour » y ramène.
export const orderLink = (orderId: string, from: string) =>
  `/commande/${orderId}?retour=${encodeURIComponent(from)}`;

const BACK_LABELS: [prefix: string, label: string][] = [
  ['/journal', 'Historique'],
  ['/recherche', 'Recherche'],
];

// Seul un chemin interne est repris : le paramètre vient de l'URL, il ne doit jamais mener hors de l'application.
export const backTarget = (value: unknown) => {
  if (typeof value !== 'string') return undefined;
  if (!value.startsWith('/') || value.startsWith('//')) return undefined;
  const label = BACK_LABELS.find(([prefix]) => value.startsWith(prefix))?.[1];
  return label ? { to: value, label } : undefined;
};
